import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/app',
    redirect: '/app/dashboard',
    component: () => import('../views/Dashboard'),
    children: [
      {
        path: '/app/dashboard',
        redirect: '/app/dashboard/home',
        component: () => import('../views/Menu/Menu'),
        children: [
          {
            path: '/app/dashboard/home',
            name: 'Menu',
            component: () => import('../views/Menu/Home'),
          },
          
          {
            path: '/app/dashboard/approvals/vehicle',
            name: 'VehicleApprovals',
            component: () => import('../views/Menu/Approvals/VehicleApprovals'),
          },
          {
            path: '/app/dashboard/approvals/pet',
            name: 'PetApprovals',
            component: () => import('../views/Menu/Approvals/PetApprovals'),
          },
          {
            path: '/app/dashboard/approvals/gadget',
            name: 'GadgetApprovals',
            component: () => import('../views/Menu/Approvals/GadgetApprovals'),
          },
          {
            path: '/app/dashboard/approvals/health',
            name: 'HealthApprovals',
            component: () => import('../views/Menu/Approvals/HealthApprovals'),
          },
          {
            path: '/app/dashboard/claims',
            name: 'Claims',
            component: () => import('../views/Menu/Claims'),
          },
          {
            path: '/app/dashboard/customers',
            name: 'Claims',
            component: () => import('../views/Menu/Customer'),
          },
          {
            path: '/app/dashboard/cancelrequests',
            name: 'Cancel',
            component: () => import('../views/Menu/CancelRequests'),
          },
        ]
      },
      {
        path: '/app/dashboard/vehicle',
        redirect: '/app/dashboard/vehicle/menu',
        component: () => import('../views/Vehicle/Menu'),
        children: [
          {
            path: '/app/dashboard/vehicle',
            name: 'VehicleMenu',
            component: () => import('../views/Vehicle/Vehicle'),
          } 
        ]
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  store.commit('showMobileNav', false)
  window.scrollTo(0, 0);
  next()
})
export default router
